import { render, staticRenderFns } from "./form-action.vue?vue&type=template&id=e300b5ca"
import script from "./form-action.vue?vue&type=script&lang=js"
export * from "./form-action.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports